import { render } from "./Favourite.vue?vue&type=template&id=96034f04"
import script from "./Favourite.vue?vue&type=script&lang=js"
export * from "./Favourite.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__